import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import Index from "@/pages/Index";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import KidsDashboard from "@/pages/KidsDashboard";
import Lessons from "@/pages/Lessons";
import LessonPage from "@/pages/LessonPage";
import Games from "@/pages/Games";
import Community from "@/pages/Community";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLessons from "@/pages/admin/AdminLessons";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminCreateLesson from "@/pages/admin/AdminCreateLesson";
import AdminEditLesson from "@/pages/admin/AdminEditLesson";
import AdminPartners from "@/pages/admin/partners";
import AdminCommunity from "@/pages/admin/AdminCommunity";
import AchievementsPage from "@/pages/AchievementsPage";
import CalculatorGamePage from "@/pages/games/CalculatorGamePage";
import CoinsGamePage from "@/pages/games/CoinsGamePage";
import MemoryGamePage from "@/pages/games/MemoryGamePage";
import BudgetGamePage from "@/pages/games/BudgetGamePage";
import SavingsGamePage from "@/pages/games/SavingsGamePage";
import BusinessGamePage from "@/pages/games/BusinessGamePage";
import Affiliates from "@/pages/Affiliates";
import DigitalLibrary from "@/pages/DigitalLibrary";
import AdminLibrary from "@/pages/admin/AdminLibrary";
import PartnerDashboard from "@/pages/PartnerDashboard";
import MaterialReader from "@/pages/library/article/[materialId]";
import EditMaterial from "@/pages/admin/EditMaterial";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import { PartnerProtectedRoute } from "../partners/PartnerProtectedRoute";
import ParentDashboard from "@/pages/ParentDashboard";
import CerebrixExchange from "@/pages/CerebrixExchange";

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Index />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/success" element={<Success />} />
      <Route path="/cancel" element={<Cancel />} />
      
      {/* Protected Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <KidsDashboard />
        </ProtectedRoute>
      } />

      {/* Parent Dashboard */}
      <Route path="/control" element={
        <ProtectedRoute>
          <ParentDashboard />
        </ProtectedRoute>
      } />

      {/* Games Routes */}
      <Route path="/games" element={
        <ProtectedRoute>
          <Games />
        </ProtectedRoute>
      } />
      <Route path="/games/calculator" element={
        <ProtectedRoute>
          <CalculatorGamePage />
        </ProtectedRoute>
      } />
      <Route path="/games/coins" element={
        <ProtectedRoute>
          <CoinsGamePage />
        </ProtectedRoute>
      } />
      <Route path="/games/memory" element={
        <ProtectedRoute>
          <MemoryGamePage />
        </ProtectedRoute>
      } />
      <Route path="/games/budget" element={
        <ProtectedRoute>
          <BudgetGamePage />
        </ProtectedRoute>
      } />
      <Route path="/games/savings" element={
        <ProtectedRoute>
          <SavingsGamePage />
        </ProtectedRoute>
      } />
      <Route path="/games/business" element={
        <ProtectedRoute>
          <BusinessGamePage />
        </ProtectedRoute>
      } />

      {/* Library Routes */}
      <Route path="/library" element={
        <ProtectedRoute>
          <DigitalLibrary />
        </ProtectedRoute>
      } />
      <Route path="/library/article/:materialId" element={
        <ProtectedRoute>
          <MaterialReader />
        </ProtectedRoute>
      } />

      {/* Admin Routes */}
      <Route path="/admin" element={
        <ProtectedRoute adminOnly>
          <AdminDashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin/lessons" element={
        <ProtectedRoute adminOnly>
          <AdminLessons />
        </ProtectedRoute>
      } />
      <Route path="/admin/lessons/create" element={
        <ProtectedRoute adminOnly>
          <AdminCreateLesson />
        </ProtectedRoute>
      } />
      <Route path="/admin/lessons/edit/:lessonId" element={
        <ProtectedRoute adminOnly>
          <AdminEditLesson />
        </ProtectedRoute>
      } />
      <Route path="/admin/users" element={
        <ProtectedRoute adminOnly>
          <AdminUsers />
        </ProtectedRoute>
      } />
      <Route path="/admin/settings" element={
        <ProtectedRoute adminOnly>
          <AdminSettings />
        </ProtectedRoute>
      } />
      <Route path="/admin/library" element={
        <ProtectedRoute adminOnly>
          <AdminLibrary />
        </ProtectedRoute>
      } />
      <Route path="/admin/library/edit/:materialId" element={
        <ProtectedRoute adminOnly>
          <EditMaterial />
        </ProtectedRoute>
      } />
      <Route path="/admin/community" element={
        <ProtectedRoute adminOnly>
          <AdminCommunity />
        </ProtectedRoute>
      } />
      <Route path="/admin/partners" element={
        <ProtectedRoute adminOnly>
          <AdminPartners />
        </ProtectedRoute>
      } />
      <Route path="/community" element={
        <ProtectedRoute>
          <Community />
        </ProtectedRoute>
      } />

      {/* Partner Routes */}
      <Route path="/partners" element={
        <PartnerProtectedRoute>
          <PartnerDashboard />
        </PartnerProtectedRoute>
      } />

      {/* Other Protected Routes */}
      <Route path="/lessons" element={
        <ProtectedRoute>
          <Lessons />
        </ProtectedRoute>
      } />
      <Route path="/lessons/:lessonId" element={
        <ProtectedRoute>
          <LessonPage />
        </ProtectedRoute>
      } />
      <Route path="/achievements" element={
        <ProtectedRoute>
          <AchievementsPage />
        </ProtectedRoute>
      } />
      <Route path="/affiliates" element={
        <ProtectedRoute>
          <Affiliates />
        </ProtectedRoute>
      } />
      <Route path="/exchange" element={
        <ProtectedRoute>
          <CerebrixExchange />
        </ProtectedRoute>
      } />
    </Routes>
  );
};
